// Module
var code = "<svg viewBox=\"0 0 30 26\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M26.6224 26H0C8.97766 26 16.384 12.1885 22.2189 3.05871C23.4613 1.11478 25.6296 0 27.9386 0H28.8166C29.5336 0 30.0858 0.631899 29.9889 1.3415L26.6224 26Z\"/> </svg> ";
// Exports
module.exports = code;